/* ============================================
   BRIGHT LIGHTS NYC — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // --- HEADER SCROLL ---
  const header = document.querySelector('.site-header');
  const announcementBar = document.querySelector('.announcement-bar');
  
  if (header) {
    if (announcementBar) header.classList.add('has-announcement');
    
    const onScroll = () => {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
        header.classList.remove('has-announcement');
      } else {
        header.classList.remove('scrolled');
        if (announcementBar) header.classList.add('has-announcement');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- MOBILE NAV ---
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');
  
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    if (mobileClose) {
      mobileClose.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // --- CART DRAWER ---
  const cartDrawer = document.querySelector('#cart-drawer');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartOverlay = cartDrawer?.querySelector('.cart-drawer__overlay');
  const cartClose = cartDrawer?.querySelector('.cart-drawer__close');

  const openCart = () => {
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  };

  cartTriggers.forEach(t => t.addEventListener('click', openCart));
  cartOverlay?.addEventListener('click', closeCart);
  cartClose?.addEventListener('click', closeCart);

  // --- SCROLL REVEAL ---
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(el => observer.observe(el));
  }

  // --- PARTICLE CANVAS HERO ---
  const canvas = document.querySelector('#hero-canvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let particles = [];
    let animId;

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener('resize', resize, { passive: true });

    class Particle {
      constructor() { this.reset(); }
      reset() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.size = Math.random() * 1.5 + 0.3;
        this.speedX = (Math.random() - 0.5) * 0.3;
        this.speedY = (Math.random() - 0.5) * 0.3 - 0.1;
        this.opacity = Math.random() * 0.7 + 0.1;
        this.life = 0;
        this.maxLife = Math.random() * 300 + 200;
        const palette = ['201,168,76', '240,208,128', '255,255,255'];
        this.color = palette[Math.floor(Math.random() * palette.length)];
      }
      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        this.life++;
        if (this.life > this.maxLife || this.y < 0) this.reset();
      }
      draw() {
        const fade = this.life < 60 ? this.life / 60 : this.life > this.maxLife - 60 ? (this.maxLife - this.life) / 60 : 1;
        ctx.save();
        ctx.globalAlpha = this.opacity * fade;
        ctx.fillStyle = `rgba(${this.color}, 1)`;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    const PARTICLE_COUNT = 120;
    for (let i = 0; i < PARTICLE_COUNT; i++) {
      const p = new Particle();
      p.life = Math.random() * p.maxLife;
      particles.push(p);
    }

    let scrollY = 0;
    window.addEventListener('scroll', () => { scrollY = window.scrollY; }, { passive: true });

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const parallaxOffset = scrollY * 0.3;
      ctx.save();
      ctx.translate(0, -parallaxOffset);
      particles.forEach(p => { p.update(); p.draw(); });
      ctx.restore();
      animId = requestAnimationFrame(animate);
    };
    animate();
  }

  // --- COUNTDOWN TIMER ---
  const countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    const targetDate = new Date(countdownEl.dataset.countdown);
    const daysEl = countdownEl.querySelector('[data-days]');
    const hoursEl = countdownEl.querySelector('[data-hours]');
    const minsEl = countdownEl.querySelector('[data-mins]');
    const secsEl = countdownEl.querySelector('[data-secs]');

    const pad = n => String(n).padStart(2, '0');

    const tick = () => {
      const diff = targetDate - new Date();
      if (diff <= 0) {
        countdownEl.innerHTML = '<p class="label">Available Now</p>';
        return;
      }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    };
    tick();
    setInterval(tick, 1000);
  }

  // --- TICKER DUPLICATE ---
  const tickerTrack = document.querySelector('.ticker__track');
  if (tickerTrack) {
    tickerTrack.innerHTML += tickerTrack.innerHTML;
  }

  // --- QUICK ADD TO CART ---
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.quickAdd;
      try {
        btn.textContent = 'Adding...';
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          btn.textContent = '✓ Added';
          setTimeout(() => { btn.textContent = 'Quick Add'; }, 2000);
          openCart();
          updateCartCount();
        }
      } catch (err) {
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = 'Quick Add'; }, 2000);
      }
    });
  });

  // --- CART COUNT UPDATE ---
  const updateCartCount = async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = document.querySelectorAll('.cart-count');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  };
  updateCartCount();

  // --- NEWSLETTER FORM ---
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = newsletterForm.querySelector('.newsletter-input');
      const btn = newsletterForm.querySelector('.btn');
      const email = input?.value;
      if (!email) return;
      btn.textContent = 'Subscribing...';
      // Shopify handles customer email capture via customer/register or contact forms
      // This fires the Shopify contact form endpoint
      setTimeout(() => {
        btn.textContent = '✓ You\'re In';
        input.value = '';
        setTimeout(() => { btn.textContent = 'Subscribe'; }, 3000);
      }, 800);
    });
  }

});
